export default __webpack_public_path__ + "static/media/PURPLE_YELLOW_BLACK.0219daeb.png";